export const ConfigType = {
  EXTERNAL_USER_MANUAL: 'EXTERNAL_USER_MANUAL',
}
